module.exports = "\n<div class=\"__dragster\" style=\"clear: both\">\n    <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/std/Dragster.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/std/Dragster.vue
// module chunks = 54